import React from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import PriceInput from '../../PriceInput'

const AttributePriceInput = ({
                               blueprint,
                               parentBlueprint,
                               factsheetBlueprint,
                               factInstanceKey,
                               data,
                               collapsed,
                               putAttribute,
                               deleteAttribute,
                               putValidationStatus,
                             }) => {
  return <PriceInput
    selectedBlueprint={blueprint}
    priceAttributeBlueprints={[blueprint]}
    parentBlueprint={parentBlueprint}
    factsheetBlueprint={factsheetBlueprint}
    factInstanceKey={factInstanceKey}
    data={data}
    collapsed={collapsed}
    putAttribute={putAttribute}
    deleteAttribute={deleteAttribute}
    putValidationStatus={putValidationStatus}
  />
}

AttributePriceInput.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
}

export default AttributePriceInput
